import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { UserRole } from '../types/user';
import { roleMatches } from '../stores/authStore';

type RequireRoleProps = {
  role: UserRole;
  children: ReactNode;
};

export function RequireRole({ role, children }: RequireRoleProps) {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  if (!roleMatches(user, role)) {
    const fallback =
      user.role === UserRole.ADMIN ? '/admin/dashboard' : '/portal/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
